var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "navigation__menu__group" }, [
    !_vm.hideGroupLabel
      ? _c("li", { staticClass: "navigation__menu__item" }, [
          _c("span", { staticClass: "navigation__menu__label" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.translateLabel(_vm.navGroupItem)) +
                "\n    "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "navigation__menu__list" },
      _vm._l(_vm.navItems, function (navItem) {
        return _c(
          "li",
          { key: navItem.label, staticClass: "navigation__menu__item" },
          [
            navItem.type === "link"
              ? _c(
                  "a",
                  {
                    staticClass: "navigation__menu__link",
                    class: {
                      "navigation__menu__link--active": navItem.isActive,
                    },
                    attrs: { href: navItem.data.url },
                  },
                  [
                    _c("i", { staticClass: "icon", class: navItem.icon }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translateLabel(navItem)) +
                        "\n      "
                    ),
                  ]
                )
              : navItem.type === "external"
              ? _c(
                  "a",
                  {
                    staticClass: "navigation__menu__link",
                    attrs: { href: navItem.data.url, target: "_blank" },
                  },
                  [
                    _c("i", { staticClass: "icon", class: navItem.icon }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translateLabel(navItem)) +
                        "\n      "
                    ),
                  ]
                )
              : navItem.type === "modal"
              ? _c(
                  "span",
                  {
                    staticClass: "navigation__menu__link",
                    on: { click: _vm.openModal },
                  },
                  [
                    _c("i", { staticClass: "icon", class: navItem.icon }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translateLabel(navItem)) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }